export default {
  currentUser: null,
  loadedModules: []
};
